module.exports = __webpack_public_path__ + "img/20190924154344445.2edefde2.jpg";